import { CSSProperties } from "react";
import FontWeight from "../../../../../models/constants/FontWeight";

export default class IntroductionViewStyle {

    backgroundWrapper : CSSProperties = {
        flex : 1,
        display : 'flex',
        flexDirection : 'row',
        justifyContent : 'space-between',
        backgroundColor : '#ECF6F9',
        borderRadius : '10px',
        marginTop : 20
    }

    contentWrapper : CSSProperties = {
        margin : '20px 0 20px 20px'
    }

    sectionTitle : CSSProperties = {
        marginBottom : 10,
        display : 'block',
        fontFamily : 'Roboto',
        fontWeight : FontWeight.MEDIUM
    }

    paragraph : CSSProperties = {
        fontFamily : 'Roboto',
        fontWeight : FontWeight.LIGHT,
        fontSize : 13,
        color : '#2F2F2F'
    }

    doctorWrapper : CSSProperties = {
        padding : '0 35px',
        display : 'flex',
        alignItems : 'flex-end',
        justifyContent : 'center',
        position : 'relative'
    }

    doctorBackground : CSSProperties = {
        position : 'absolute',
        width : 115,
        bottom : 0
    }

    doctor : CSSProperties = {
        width : 95,
        height : 'auto',
        zIndex : 2
    }
}